import { updateContentTypes, updatePromptContent } from '../store/SmartCreateStore';

import type { ContentType } from './ContentTypes';

export type ObjectExampleData = {
	product?: string;
	title: string;
	contentType: ContentType;
	hoverColor?: string;
	prompt: string;
};

export type ObjectExamplesConfig = Record<string, ObjectExampleData>;

export const chooseObjectExample = (choice: string, examples: ObjectExamplesConfig) => {
	const example = examples[choice];
	if (!example) {
		return;
	}

	const { prompt, contentType } = example;
	updatePromptContent(prompt);
	updateContentTypes([contentType]);
};
